<template>
    <div class="Signin flex flex-1 col-center">
        <div class="Logo">
            <img src="@/assets/images/logos/qualitas-logo.svg">
        </div>
        <TheLogin
            :disabled="isLoading"
            :devLogin="devLogin"
            @onLogin="handleSignin"
        />
        <Notification
            group="global"
            position="bottom left"
        />
    </div>
</template>

<script>
import {
    mapActions, mapGetters,
} from 'vuex'
import { TheLogin, Notification } from '@/components'
import Config from '@/config'

export default {
    name: 'SigninScreen',
    components: {
        TheLogin,
        Notification,
    },
    metaInfo () {
        return {
            title: this.$t('navigation.auth'),
        }
    },
    data () {
        return {
            devLogin: this.$DEV ? Config.auth.dev : undefined,
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'auth/isLoading',
        }),
    },
    methods: {
        ...mapActions({
            signin: 'auth/signin',
            signout: 'auth/signout',
        }),
        handleSignin (form) {
            this.signin(form)
                .catch(() => this.signout())
                .then(() => this.$router.push({ name: 'Main' }))
        },
    },
}
</script>
<style scoped lang="scss">
.Signin {
	min-height: 100vh;
    background-color: #000;
    
	.Logo {
		width: 120px;
		position: absolute;
		top: 40px;
        left: 55px;

		img {
			width: 100%;
			height: 100%;
		}
	}
}
</style>
